"use strict";

var Gender;
(function (Gender) {
  Gender[Gender["GENDER_MALE"] = 1] = "GENDER_MALE";
  Gender[Gender["GENDER_FEMALE"] = 2] = "GENDER_FEMALE";
  Gender[Gender["GENDER_COUPLE"] = 3] = "GENDER_COUPLE";
  Gender[Gender["GENDER_TRANSVESTITE"] = 4] = "GENDER_TRANSVESTITE";
})(Gender || (Gender = {}));